module.exports = __webpack_public_path__ + "5cfe73ff088da81546fbdcba899c3469.png";